import { Component, OnInit } from '@angular/core';
import {AuthService} from '../auth/auth.service';
import {AdminGuard} from '../admin-guard.service';
import {Router, ActivatedRoute } from '@angular/router';
import {AngularFireDatabase, FirebaseListObservable, FirebaseObjectObservable} from 'angularfire2/database';

@Component({
  selector: 'app-dashboard',
  templateUrl: './full-layout.component.html'
})
export class FullLayoutComponent implements OnInit {

  public disabled = false;
  public status: {isopen: boolean} = {isopen: false};
  router: Router;
  routParam: string;
  uid: String;
  url:String;
  urlArray;
  isAdmin: boolean;
  checkedAdmin: boolean;
  sub;
  listSaved: FirebaseListObservable<any>;
  userObject: FirebaseObjectObservable<any>;
  numberChecker: number;

  constructor(public authService: AuthService, public _router: Router, private db: AngularFireDatabase, private route: ActivatedRoute, private adminGuard: AdminGuard ) {
  this.router = _router
  this.isAdmin = false;
  this.checkedAdmin = false;
  this.sub = this.authService.user.subscribe(
      (auth) => {
        if (auth == null) {
          console.log('Not Logged in.');
          this.router.navigate(['signin']);
        } else {
          this.uid = auth.uid;
          console.log(this.uid);
          this.userObject = this.db.object('/ownership/answers/' + this.uid);
          //checks if the user has admin rights
          this.userObject.subscribe(constant => {
            this.isAdmin = constant.isAdmin;
            if (!this.checkedAdmin){
              this.adminGuard.checkAdmin(this.isAdmin);
              this.checkedAdmin = true;
            }
          })
          this.listSaved = db.list('/ownership/answers/' + this.uid + '/saved');
          this.listSaved.subscribe(items => {
              items.forEach(item => {
            });
        })
        }

      });

  }

  logout() {
    this.authService.logout();
  }

  /*function to delete saved forms and routes them back to the default so they can't access a form
  they just deleted */ 
  deleteAddCost(key: string, event){
    this.listSaved.remove(key);
    this.url = this.router.url;
    if (!(this.url === '/CostofOwnership/ownership-form/default'))
    {
      console.log("Were navigating");
      this.router.navigateByUrl('/CostofOwnership/ownership-form/default');
    }
  }
  public toggled(open: boolean): void {
    console.log('Dropdown is now: ', open);
  }

  public toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.status.isopen = !this.status.isopen;
  }

  ngOnInit(){
  }

  ngOnDestroy(){
    this.sub.unsubscribe();
  }


}



// WEBPACK FOOTER //
// ./src/app/layouts/full-layout.component.ts